import React from 'react';
import PropTypes from 'prop-types';
import Script from 'next/script';

const OptimizeAntiFlicker = () => (
    <style
        dangerouslySetInnerHTML={{
            __html: '.async-hide { opacity: 0 !important}',
        }}
    />
);

const Optimize = ({ code }) => code && (
    <Script id={'optimize'} strategy={'beforeInteractive'}>
        {
            `(function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;
                    h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};
                    (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;
                    })(window,document.documentElement,'async-hide','dataLayer',4000,
                    {'${code}':true});`
        }
    </Script>
);

Optimize.propTypes = {
    code: PropTypes.string,
};

export default Optimize;
export { OptimizeAntiFlicker };
